import React from "react";
import { X, Check } from "lucide-react";

const DeactivationModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-w-md w-full p-6 rounded-lg relative shadow-lg">
        <div className="flex ">
          <div className="rounded-full bg-black p-1 mb-4">
            <Check className="h-6 w-6 text-white" />
          </div>
          {/* Close Button */}
          <button
            onClick={onClose}
            className=" absolute top-8 right-4 border  rounded-full p-[2px] opacity-70 hover:opacity-100 "
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Modal Content */}
        <div className="flex flex-col  ">
          <h2 className="text-xl font-semibold mb-2">
            Your Account Deactivation Request has been registered
          </h2>

          <p className="text-gray-500">
            Our support team will reach out to you shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeactivationModal;
